// Pure helpers for the Modern Trade near-expiry returns page
// (spec 2026-11-03 §5, MtExpiryReturns.vue). The backend
// (POST /expiry-returns) runs the same qty rule under a row lock and has the
// final word; this module only keeps the dialog honest. Vue-free so jest can
// cover it directly.

function pad(n, w) {
  return String(n).padStart(w, "0");
}

// "YYYY-MM-DD" for the LOCAL calendar day. Never toISOString(): that is the
// UTC day and shifts the date back by one between 00:00 and 07:00 in Bangkok.
export function localToday(now) {
  const d = now instanceof Date ? now : new Date();
  return `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;
}

// Returned qty must be a whole number from 1 up to the lot's available qty.
// Returns null when OK, otherwise "not_positive_int" | "exceeds_available".
export function returnQtyError(qty, available) {
  if (qty === "" || qty === null || qty === undefined) return "not_positive_int";
  const n = Number(qty);
  if (!isFinite(n) || !Number.isInteger(n) || n <= 0) return "not_positive_int";
  const max = Number(available);
  if (!isFinite(max) || n > max) return "exceeds_available";
  return null;
}

// 409 insufficient_stock body → current available qty, or null.
// MtExpiryReturnCreate puts it in Datum via r.Set({available}).
export function availableFromConflict(data) {
  const d = data && data.Datum;
  return d && typeof d.available === "number" && isFinite(d.available) ? d.available : null;
}

// GET /expiry-returns/candidates → rows. MtExpiryReturnCandidates r.Append's
// each row, so Data is the bare row array (absent when there are none).
export function candidatesFromBody(body) {
  return body && Array.isArray(body.Data) ? body.Data : [];
}

// GET /expiry-returns → {items, total}. MtExpiryReturnList r.Append's one
// object {items, total, page, per_page}, so it sits in Data[0].
export function historyFromBody(body) {
  const o = body && Array.isArray(body.Data) ? body.Data[0] : null;
  if (!o || !Array.isArray(o.items)) return { items: [], total: 0 };
  return { items: o.items, total: Number(o.total) || o.items.length };
}

// POST /expiry-returns body. product_id is the stock-layer id (wms_product.id)
// exactly as the candidates row carries it.
export function returnPayload(row, form) {
  const r = row || {};
  const f = form || {};
  return {
    company_id: r.company_id,
    product_id: r.product_id,
    lot_no: r.lot_no,
    qty: Number(f.qty),
    return_date: f.return_date,
    note: String(f.note == null ? "" : f.note).trim(),
  };
}
